import { LegislationFilterValues } from "../ui/components/global";

export function countFilledLegislationFields(
  filters: LegislationFilterValues,
): number {
  const { searchMode, ...rest } = filters;

  return Object.values(rest).filter((value) => value !== "" && value !== null)
    .length;
}
